import React from 'react';
import { ErrorPageTemplate } from '~/pages/ksa/dataValidation/ErrorPage';
import paths from '~/pages/paths';

const ErrorPage: React.FC = () => {
  return <ErrorPageTemplate homeLink={paths.ksa.invitation._} />;
};

export default ErrorPage;
